export default "__VITE_ASSET__1pNyJcS___"